import { Outlet, createRoute, redirect } from '@tanstack/react-router';

import { rootRoute } from '../__root';

export const authLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/auth',
  beforeLoad: ({ context }) => {
    if (context.authStore.accessToken) throw redirect({ to: '/users' });
  },
  component: () => <Outlet />,
});
